import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

function FAQ({title, faqs}) {
  
  const [openIndex, setOpenIndex] = useState(5);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 px-4 bg-white" id="faq">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-3xl font-bold text-center text-black mb-8">
          {title}
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className={`rounded-xl border-b border-gray-200 pb-4 px-4 transition-all ${isOpen ? 'bg-[#F5F7F9]' : 'bg-white'
                  }`}
              >
                <button
                  className="w-full text-left flex justify-between items-center py-4 focus:outline-none"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="font-bold text-gray-800">{faq.question}</span>
                  {isOpen ? (
                    <Minus size={20} className="text-gray-800" />
                  ) : (
                    <Plus size={20} className="text-gray-800" />
                  )}
                </button>
                {isOpen && (
                  <div className="text-gray-600 pb-4">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}

export default FAQ;